import React from "react";
import { ArrowDown, ScrollText } from "lucide-react";
import { SORTS, fmtMs, fmtNum, fmtRate } from "./monUtil";

const COLS = [["count", "Jumlah", fmtNum], ["rpm", "/mnt", fmtNum], ["p50_ms", "p50", fmtMs], ["p95_ms", "p95", fmtMs], ["p99_ms", "p99", fmtMs], ["avg_ms", "Rata²", fmtMs], ["max_ms", "Maks", fmtMs], ["errors", "Error", fmtNum], ["error_rate", "Error %", fmtRate]];

export function BreakdownTable({ data, sort, setSort, selected, onSelect, onLogs }) {
  return (
    <div className="aivora-card overflow-hidden" data-testid="mon-breakdown">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[900px] text-left text-xs">
          <thead className="bg-slate-50 text-[10px] uppercase tracking-wider text-slate-500">
            <tr>
              <th className="px-4 py-2.5 font-bold">Nama</th>
              {COLS.map(([k, l]) => (
                <th key={k} className="px-3 py-2.5 text-right font-bold">
                  {SORTS[k] ? <button onClick={() => setSort(k)} className={`inline-flex items-center gap-0.5 uppercase ${sort === k ? "text-brand" : "hover:text-slate-900"}`} data-testid={`mon-sort-${k}`}>{l}{sort === k && <ArrowDown size={10} />}</button> : l}
                </th>
              ))}
              <th className="px-3 py-2.5" />
            </tr>
          </thead>
          <tbody className="divide-y divide-line">
            {!data && [0, 1, 2].map((i) => <tr key={i}><td colSpan={11} className="px-4 py-3"><div className="h-4 animate-pulse rounded bg-slate-100" /></td></tr>)}
            {data && !data.items?.length && <tr><td colSpan={11} className="px-4 py-8 text-center text-slate-400" data-testid="mon-breakdown-empty">Tidak ada data pada window ini.</td></tr>}
            {data?.items?.map((r, i) => (
              <tr key={r.name} onClick={() => onSelect(selected === r.name ? "" : r.name)} className={`cursor-pointer transition-colors ${selected === r.name ? "bg-brand-soft" : "hover:bg-slate-50"}`} data-testid={`mon-breakdown-row-${i}`}>
                <td className="max-w-[320px] truncate px-4 py-2.5 font-mono font-semibold text-slate-900" title={r.name}>{r.name}</td>
                {COLS.map(([k, , f]) => <td key={k} className={`px-3 py-2.5 text-right font-mono ${k === "p95_ms" ? "font-bold text-slate-900" : "text-slate-600"} ${(k === "errors" || k === "error_rate") && r.errors ? "font-bold text-rose-600" : ""}`}>{f(r[k])}</td>)}
                <td className="px-3 py-2.5 text-right"><button onClick={(e) => { e.stopPropagation(); onLogs(r.name); }} className="rounded-lg p-1.5 text-slate-400 hover:bg-white hover:text-brand" title="Lihat log" data-testid={`mon-breakdown-logs-${i}`}><ScrollText size={14} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {data && <p className="border-t border-line px-4 py-2 text-[11px] text-slate-400" data-testid="mon-breakdown-total">Menampilkan {data.items?.length || 0} dari {data.total ?? 0} · klik baris untuk memfilter grafik</p>}
    </div>
  );
}
